/* eslint-disable no-console */
import {
  API_DETAIL_NOTIFICATION,
  API_GET_CERIFICATE,
  API_GET_DEVICE_NOTIFICATION,
  API_GET_NOTIFICATION,
  API_POST_CERTIFICATE_UPLOAD
} from 'configs/api'
import { DeviceNotificationParamsType, PramsGetListNoti, ReqCreateNotification } from 'models/notification'
import { bindParams } from 'utilities/helpers'
import networkAdapter from 'utilities/networkAdapter'

export const fetchListNoti = async (params: PramsGetListNoti) => {
  try {
    const postApi = await networkAdapter.get(API_GET_NOTIFICATION, params)
    return postApi.data
  } catch (error) {
    console.log('error_fetchListNoti', error)
  }
}

export const postCreateNotify = async (req: ReqCreateNotification) => {
  try {
    const postApi = await networkAdapter.post(API_GET_NOTIFICATION, req)
    return postApi
  } catch (error) {
    console.log('error_postCreateNotify', error)
  }
}

export const deleteNotificationApi = async (notifyId: number) => {
  try {
    const users = networkAdapter.delete(
      bindParams(API_DETAIL_NOTIFICATION, {
        id: notifyId
      })
    )
    return users
  } catch (error) {
    console.log('error deleteNotificationApi', error)
  }
}

export const fetchExpirationCertificateApi = async (params: { app_id: string }) => {
  try {
    const postApi = await networkAdapter.get(API_GET_CERIFICATE, params)
    return postApi.data
  } catch (error) {
    console.log('error_fetchExpirationCertificateApi', error)
  }
}

export const uploadCertificate = async (data: any) => {
  try {
    const postApi = await networkAdapter.post(API_POST_CERTIFICATE_UPLOAD, data)
    return postApi
  } catch (error) {
    console.log('error upload certificate', error)
  }
}

export const getDeviceNotificationApi = async (params: DeviceNotificationParamsType) => {
  try {
    const postApi = await networkAdapter.get(API_GET_DEVICE_NOTIFICATION, params)
    return postApi
  } catch (error) {
    console.log('error_getDeviceNotification', error)
  }
}

